// MIRRORS: panel/util/formatLocation.ts — identical copy; edit both, or delete this line on both to declare a deliberate split.

/** The location fields any listing, producer or profile carries. */
export interface LocationParts {
  city?: string | null;
  district?: string | null;
  neighbourhood?: string | null;
}

export interface FormatLocationOptions {
  /** Drops the province, for rows too narrow to carry all three levels. */
  short?: boolean;
}

/**
 * One place where a location becomes text. Reads from the most specific level
 * outwards, the way an address is spoken, and silently drops levels that are
 * missing — older listings have no mahalle, and a producer may only have set a
 * province.
 */
export function formatLocation(
  parts: LocationParts,
  { short = false }: FormatLocationOptions = {}
): string {
  return [parts.neighbourhood, parts.district, short ? null : parts.city]
    .filter((part): part is string => Boolean(part && part.trim()))
    .join(', ');
}
